// useAssessmentState.js
import { useQuery } from 'react-query';
import { getAssessmentState } from '../api';
import useCurrentUser from './useCurrentUser';
import { useContext } from 'react';
import { PartnerContext } from '../contexts';
const { token, userID } = useCurrentUser();

const useAssessmentState = () => {
  const {
    state: { id: partnerID },
  } = useContext(PartnerContext);
  const result = useQuery('assessment_state_' + partnerID + token, () => getAssessmentState(token, userID, partnerID), {
    refetchOnWindowFocus: true,
    enabled: !!partnerID, // Prevent query from running until partnerID is available
  });
  return result;
};

export default useAssessmentState;
